import React, { useMemo } from "react";
import { hasBurnedHeadline } from "../../../utils";
import { useVideoDataContext } from "../../../contexts/VideoDataContext";
import {
  LiveDot,
  LiveDotWrapper,
  PromoDuration,
  PromoTitle,
  TextContainer
} from "../index.stitches";
import { PlayerSize } from "../../../hooks/usePlayerSize";
import PropTypes from "prop-types";
import {
  getPromoText,
  getPromoTextAriaLabel,
  shouldRenderTitle
} from "../utils";

export const PromoText = ({
  playerSize,
  isEnded,
  isUpcoming,
  isVideoTypeLive,
  title,
  duration,
  config
}) => {
  const {
    showBtnText = true,
    customBtnText,
    showDurationOrLive = true,
    isLivePreviewEnabled
  } = config;

  const { videoData, isForceLoadVideo } = useVideoDataContext();

  const promoText = useMemo(
    () =>
      getPromoText(
        isForceLoadVideo,
        title,
        customBtnText,
        isLivePreviewEnabled,
        isUpcoming
      ),
    [customBtnText, isForceLoadVideo, isLivePreviewEnabled, isUpcoming, title]
  );

  const burnedHeadline = hasBurnedHeadline(videoData);

  const renderTitle = useMemo(
    () =>
      shouldRenderTitle(showBtnText, isEnded, burnedHeadline, customBtnText),
    [burnedHeadline, customBtnText, isEnded, showBtnText]
  );

  const showLiveDot = isVideoTypeLive && !isEnded;
  const hideDuration = isVideoTypeLive && isEnded;

  return (
    <TextContainer small={playerSize === PlayerSize.SMALL}>
      {renderTitle && (
        <PromoTitle
          id={`orca-promo-title`}
          aria-hidden={isUpcoming ? false : true}
          aria-label={getPromoTextAriaLabel(isVideoTypeLive, title)}
          data-testid="promo-title"
          role="heading"
        >
          {promoText}
        </PromoTitle>
      )}
      {showDurationOrLive && (
        <PromoDuration
          id={`orca-promo-duration`}
          aria-hidden="true"
          className="overrideStyles"
          data-testid="promo-duration"
          hidden={hideDuration}
        >
          {showLiveDot ? (
            <LiveDotWrapper>
              <LiveDot id={"orca-promo-live-dot"} />
              Live
            </LiveDotWrapper>
          ) : (
            duration.visible
          )}
        </PromoDuration>
      )}
    </TextContainer>
  );
};

PromoText.propTypes = {
  playerSize: PropTypes.string,
  isEnded: PropTypes.bool,
  isUpcoming: PropTypes.bool,
  isVideoTypeLive: PropTypes.bool,
  title: PropTypes.string,
  duration: PropTypes.object,
  config: PropTypes.object
};
